/* eslint-disable no-param-reassign */
const getInitialState = () => ({
  schemesOfWork: undefined,
  schemesOfWorkTemplates: undefined,
  termInfo: undefined,
});

const schemesOfWorkSlice = (set, get) => ({
  sliceName: 'schemesOfWork',
  getInitialState,
  onConnected: (data) => {
    const { schemesOfWork } = data;
    const { setSchemesOfWork } = get();
    if (schemesOfWork) {
      setSchemesOfWork(schemesOfWork);
    }
  },
  selectors: {
    ...getInitialState(),

    getSchemeOfWork: (sowId) =>
      get().schemesOfWork.find((sow) => sow.id === sowId),
  },
  mutators: {
    setSchemesOfWork: (schemesOfWork, schemesOfWorkType = 'SCHEME_OF_WORK') =>
      set((draft) => {
        if (schemesOfWorkType === 'SCHEME_OF_WORK') {
          draft.schemesOfWork = schemesOfWork;
        } else if (schemesOfWorkType === 'SCHEME_OF_WORK_TEMPLATE') {
          draft.schemesOfWorkTemplates = schemesOfWork;
        }
      }),

    updateSchemeOfWork: (schemeOfWork) =>
      set((draft) => {
        const key =
          schemeOfWork.type === 'SCHEME_OF_WORK_TEMPLATE'
            ? 'schemesOfWorkTemplates'
            : 'schemesOfWork';

        const schemesOfWork = draft[key] ?? (draft[key] = []);
        const currentIndex = schemesOfWork.findIndex(
          (sow) => sow.id === schemeOfWork.id
        );

        if (currentIndex !== -1) {
          schemesOfWork[currentIndex] = schemeOfWork;
        } else {
          schemesOfWork.push(schemeOfWork);
        }
      }),

    deleteSchemeOfWork: (schemeOfWorkId) =>
      set((draft) => {
        const currentIndex = draft.schemesOfWork.findIndex(
          (sow) => sow.id === schemeOfWorkId
        );
        if (currentIndex !== -1) {
          draft.schemesOfWork.splice(currentIndex, 1);
        }
      }),

    publishSchemeOfWork: (schemeOfWorkId) =>
      set((draft) => {
        const schemeOfWork = draft.schemesOfWork?.find(
          (sow) => sow.id === schemeOfWorkId
        );
        if (schemeOfWork) {
          schemeOfWork.status = 'published';
        }
      }),

    unpublishSchemeOfWork: (schemeOfWorkId) =>
      set((draft) => {
        const schemeOfWork = draft.schemesOfWork?.find(
          (sow) => sow.id === schemeOfWorkId
        );
        if (schemeOfWork) {
          schemeOfWork.status = 'draft';
        }
      }),

    setTermInfo: (termInfo) =>
      set((draft) => {
        draft.termInfo = termInfo;
      }),
  },
});

export default schemesOfWorkSlice;
